<template>
  <div class="d-flex align-items-center bg-auth border-top border-top-2 border-primary">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 col-md-5 col-xl-4 my-5">
            <h1 class="display-4 text-center mb-3">Online Sınav</h1>
            <div class="alert alert-primary" v-if="message">{{ message }}</div>
            <p class="text-muted text-center mb-5" v-else>TC kimlik numaranız ve şifreniz ile giriş sağlayarak kullanmaya başlayabilirsiniz.</p>
            <form @submit.prevent="handleLogin">
              <div class="form-group">
                <label>TC Kimlik Numaranız</label>
                <input type="text" name="id" v-model="kimlikNo" class="form-control" placeholder="00000000000">
                <div v-show="submitted && !kimlikNo" class="invalid-feedback">Bu alan boş kalmamalıdır!</div>
              </div>
              <div class="form-group">
                <label>Şifreniz</label>
                <input type="password" name="key" v-model="sifre" class="form-control" placeholder="******">
                <div v-show="submitted && !sifre" class="invalid-feedback">Bu alan boş kalmamalıdır!</div>
              </div>
              <div class="form-group">
                <button class="btn btn-lg btn-block btn-primary mb-3" :disabled="loading">Giriş Yap</button>
                <div class="text-center">
                  <small class="text-muted text-center">
                    <a class="text-muted" href="#">Bilfen Eğitim Kurumları &copy; {{ this.getYear }}</a>
                  </small>
                </div>
              </div>
            </form>
        </div>
      </div> <!-- / .row -->
    </div>
  </div>
</template>
<script>
import base from '@/mixins/base';
export default {
  mixins: [base],
  name: 'Login',
  data() {
    return {
      message: '',
      title: 'Giriş',
      sifre: '',
      kimlikNo: '',
      loading: false,
      submitted: false,
      isLogged: false
    }
  },
  head: {
    title: function () {
      return {
        inner: this.title
      }
    },
  },
  methods: {
    handleLogin () {
      this.submitted = true
      this.loading = true
      this.$nprogress.start()
      const { kimlikNo, sifre } = this;
      if (kimlikNo && sifre) {
        localStorage.clear()
        this.authData(kimlikNo, sifre);
        let actionPromise = setInterval(() => {
          if (this.$store.state.auth.student != null) {
            this.loading = false
            this.$nprogress.done();
            clearInterval(actionPromise);
            setTimeout( () => {
              this.$router.push({ name: 'Home' });
            }, 500)
          } else {
            this.$nprogress.done();
            if (this.$store.state.auth.error != null) {
              this.message = this.$store.state.auth.error;
            } else {
              this.message = 'Sunucudan gelen sonuçta bir sorun vardı. Daha sonra tekrar deneyin.'
            }
            this.loading = false
          }
        }, 1000);
      }
    }
  },
  created() {
    if (this.$store.state.auth.isLogged) {
      this.$router.push({ name: 'Home' })
    } else if (this.$route.query.hata !== undefined) {
      if (this.$route.query.hata == 'ogrenci-numarasi-alinamadi') {
        this.area = 'studentProblem'
      } else {
        this.area = 'tokenProblem'
      }
      this.$router.push({ name: 'Home' });
      this.area = 'auth'
      this.title = 'Bir sorun oluştu! 🤔'

    } else if (this.$route.query.token !== undefined) {
      /*
      this.area = 'authProcess'
      this.title = 'Oturum Kontrolü'
      this.$nprogress.start()
      setTimeout(() => {
        localStorage.clear()
        let action = this.authData(this.$route.query.token);
        if (action) {
          this.$nprogress.done();
          setTimeout( () => {
              this.$router.push({ name: 'Home' });
            }, 500)
        } else {
          this.$nprogress.done();
          this.message = action;
        }
      }, 500);
      */
    }

    setInterval(() => {
      this.isLogged = this.$store.state.auth.isLogged;
    }, 100);
  },
  watch: {
    isLogged: function(val) {
      if (val) {
        // this.$router.push({ name: 'Home' })
      }
    }
  }
}
</script>
